
var Model = require("../types/Model.js");
var xtend = require("xtend");
var Promise = require("promise");
var isObject = require("isobject");

module.exports = Model({
	name: "atouchawaymessaging",
	_isGroup: false,
	_apiPrefix: null,
	_groupchat_tracker: null,
	_localization: null,

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	get_simple_date: get_simple_date,
	get_date: get_date,
	get_month: get_month,
	get_day: get_day,
	scroll_down: scroll_down,
	get_messages: get_messages,
	defaultMessage: defaultMessage,
	handle_view_cancel: handle_view_cancel,
	handle_view_deeplink: handle_view_deeplink,
	handle_view: handle_view,
	handle_clear: handle_clear,
	track_group_events: track_group_events,
	recalculate: recalculate,
	view_update: view_update,
	view_group: view_group,
	view_non_group: view_non_group
});

function init(){
	this._isGroup = false;
	this._apiPrefix = null;
	this._localization = null;
	this._propup = false;
	this._settings = null;
	this._who = null;
	this._prevContacts = [];
	this._groupchat_tracker = this.dispatcher.createTracker();
	this.push({
		list: [],
		who: null,
		page: 0,
		unreadList: [],
		viewing: null,
		loadMore: false,
		defaultMessage: ""
	});
}

function uninit(){
	this._groupchat_tracker.off();
	this._groupchat_tracker = null;
	this.emit("usermetrics:trigger:track", "close atouchaway messaging");
}

function listeners(){
	return {
		"people:updated": Model.makeRecalculator("people"),
		"groups:updated": handle_groups_updated,
		"mqtt:$/message": handle_new_message,
		"mqtt:$/message/read/from": handle_message_read,
		"localization:updated": handle_localization_updated,
		"atouchawaysettings:updated": handle_atouchaway_settings_updated,
		"contacts:updated": handle_contacts_update
	};
}

function triggers(){
	return {
		"view:popup": handle_view_popup,
		"view:read": handle_view_read,
		"view:cancel": handle_view_cancel,

		"view:deeplink": handle_view_deeplink,

		"view": handle_view,
		"next": handle_next_page,

		"clear": handle_clear,
		"send": handle_send,
		"default": defaultMessage
	};
}

function recalculate(){
	var users = this._people;
	var messages = this.data.list;
	var personalId = this.config.id;
	var who = this._who;

	if(users) {
		var newMessages = messages.map(function(message, index){
			var update = {};
			if(message.type.indexOf("systemmessage") !== -1){
				var data = message.metadata.data;
				var person;
				if(isObject(data)) person = users[data._id];
				else person = users[data];
				if(!person)
					return message;
				update = {
					metadata: {
						type: message.metadata.type,
						data: person
					}
				};
			} else {
				var messageFrom;
				if(isObject(message.from)) messageFrom = users[message.from._id];
				else messageFrom = users[message.from];
				if(!messageFrom){
					this.emit("people:trigger:add", {
						lean: true,
						who: message.from
					});
					return message;
				}
				update = {
					from: messageFrom
				};
			}

			var newRead;
			var from = message.from;
			if(this._isGroup && index === (messages.length - 1))
				newRead = message.read.filter(function(readPerson){
					if(isObject(readPerson))
						return readPerson._id !== personalId;
					else
						return readPerson !== personalId;
				}).filter(function(p){
					if(isObject(p))
						return isObject(from) ? p._id !== from._id : p._id !== from;
					else
						return isObject(from) ? p !== from._id : p !== from;
				}).map(function(readPerson){
					var personObj;
					if(isObject(readPerson)) personObj = users[readPerson._id];
					else personObj = users[readPerson];
					if(!personObj)
						return readPerson;
					else return personObj;
				});

			if(newRead)
				update.read = newRead;
			return xtend(message, update);
		}.bind(this));

		var members = [];
		if(this._isGroup && who){
			members = who.members.map(function(member){
				if(isObject(member)) return users[member._id];
				let user = users[member];
				if(!user){
					user = {fname: "...", lname: ""};
				}
				return user;
			});
		}

		var update = {};

		var shouldUpdate = false;

		if(newMessages.length > 0){
			shouldUpdate = true;
			update.list = newMessages;
		}

		if(members.length > 0){
			shouldUpdate = true;
			update.who = xtend(who, {
				members: members
			});
		}

		if(!this._isGroup && who && users) {
			const id = who;
			const user = users[id];

			if(user && who && user !== who ) {
				shouldUpdate = true;
				update.who = user;
			}
		}
		if(shouldUpdate){
			this._who = who;
			this.extend(update);
		}
	}
}

function handle_atouchaway_settings_updated(data){
	var messaging = data.messaging;
	var currentMessaging = this._messaging;
	this._messaging = messaging;
	if(currentMessaging !== messaging && messaging !== "advanced"){
		this.emit("atouchawaymobile:trigger:page", {
			page: "contacts",
			dontClearMessaging: true
		});
	}
}

function handle_message_read(data){
	var from = data.from;
	var group = data.group;
	var time = data.time;
	var who = this.data.who;
	var list = this.data.list;

	if(!who)
		return;
	if((group && who._id !== group) || (!group && who._id !== from))
		return;

	var newList;
	if(this._isGroup)
		newList = list.map(function(message, index){
			if(index === (list.length - 1)){
				var read = message.read.concat(from);
				return xtend(message, {
					read: read
				});
			} else {
				return message;
			}
		});
	else
		newList = list.map(function(message, index){
			if(index === (list.length - 1)){
				var messageUpdate = {
					read: true,
					updated_at: time,
				};
				return xtend(message, messageUpdate);
			} else {
				return message;
			}
		}).map(timestampify);

	if(newList.length > 0){
		this.extend({
			list: newList
		});
		this.recalculate();
		this.scroll_down();
	}
}

function handle_localization_updated(localization) {
	this._localization = localization;
}

function handle_groups_updated(groups){
	var who = this._who;

	var ids = groups.reduce(function(idArray, element){
		return idArray.concat(element.members);
	}, []);

	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});

	this._groups = makeIdMap(groups);

	if(!who)
		return;
	if(!who.members)
		return;

	var group = who._id;
	var newGroup;
	if(Array.prototype.find)
		newGroup = groups.find(function(element){
			return element._id === group;
		});
	else
		newGroup = findGroup(groups, group);

	if(!newGroup){
		this.handle_view_cancel();
		return;
	}

	newGroup.members = who.members;

	var update = xtend(group, newGroup);
	this.extend({
		who: update
	});

	this.recalculate();
}

function handle_view_read(data){
	Promise.all([
		this.handle_clear(data),
		this.handle_view_cancel()
	]);

	this.emit("usermetrics:trigger:track", "read atouchaway messaging", {
		who: data.who
	});
}

function handle_view_cancel(){
	this._popup = false;
	this.push({
		list: [],
		unreadList: [],
		who: null,
		page: 0,
		viewing: null,
		totalMessageCount: 0,
		loadMore: false
	});
}

function handle_view_popup(data){
	var who = data.who;
	this._apiPrefix = this.api.messages;
	this.get_messages(who, 0);
	this._popup = true;
	this.extend({
		who: who
	});
	this.emit("usermetrics:trigger:track", "show atouchaway messaging popup", {
		who: who
	});
}

function handle_clear(data){
	var who = data.who;
	this.api.messages.read(who);
	this.emit("usermetrics:trigger:track", "clear atouchaway messaging notifications", {
		who: who
	});
}

function handle_next_page(){
	var page = this.data.page + 1;
	var who = this.data.who;
	this.emit("usermetrics:trigger:track", `view page ${page} atouchaway in messaging`, {
		who: who
	});
	return this.get_messages(who, page);
}

function handle_send(data){
	var who = data.who;
	var message = data.message;
	var userId = who._id;
	this.emit("keyboard:trigger:close");
	this.emit("persiststorage:delete", {
		dataId: userId
	});

	this.emit("usermetrics:trigger:track", "send atouchaway message", {
		who: userId
	});

	return this._apiPrefix.send.message(who._id, message)
		.then(handle_sent_message.bind(this));
}

function handle_view_deeplink(data){
	const who = data.who;
	this._who = who._id;
	this.handle_view(data);
	this.emit("people:trigger:add", {
		lean: true,
		who: who._id
	});
	this.dispatch("opened");
}

function handle_view(data){
	this.emit("keyboard:trigger:close");
	this._isGroup = false;
	this._apiPrefix = this.api.messages;
	this._groupchat_tracker.off();
	this.handle_view_cancel();
	var who = data.who;
	var userId = who._id;
	this.defaultMessage(userId);
	if(data.group){
		return this.view_group(who);
	}
	this.view_non_group(who);
}

function view_group(who){
	this.api.groupchat.data(who._id)
		.then(function(group){
			this._who = group;
			this._isGroup = true;
			this._apiPrefix = this.api.groupchat;
			this.track_group_events(who._id);
			this.view_update(group);
		}.bind(this));
	this.emit("usermetrics:trigger:track", "open atouchaway chat with group", {
		who,
	});
}

function view_non_group(who){
	this.view_update(who);
	this.emit("usermetrics:trigger:track", "open atouchaway chat with contact", {
		who: who._id,
	});
}

function view_update(who){
	this.get_messages(who, 0)
		.then(scroll_down.bind(this));
	this._apiPrefix.read(who._id);
	this.recalculate();
	this.extend({
		who: who,
		viewing: who._id
	});
}

function handle_sent_message(message){
	if(this._isGroup)
		return;
	var list = this.data.list;
	this.extend({
		list: list.concat(timestampify(message))
	});
	this.scroll_down();
	this.recalculate();
}

function handle_new_message(message){
	var who = this.data.who;
	var list = this.data.list;
	var unreadList = this.data.unreadList;

	this.emit("screensaver:trigger:clear");
	if(!who ||
		(this._isGroup && (message.group !== who._id)) ||
		(!this._isGroup && (message.from !== who._id)))
		return;

	var simpleDateMessage = this.get_simple_date(message);
	var timestampedMessage = timestampify(message);

	this.extend({
		list: list.concat(timestampedMessage),
		unreadList: unreadList.concat(xtend(timestampedMessage, simpleDateMessage)),
		totalMessageCount: this.data.totalMessageCount + 1
	});

	if(!this._popup){
		this.scroll_down();
		this._apiPrefix.read(who._id);
	}
	this.recalculate();
}

function handle_member_added(member){
	var group = this._who;
	var member_id = member.member;

	this.emit("people:trigger:add", {
		lean: true,
		who: member_id
	});

	var newMembers = group.members.concat(member_id);

	var updatedGroup = xtend(group, {
		members: newMembers
	});

	this._who = updatedGroup;
	this.recalculate();
}

function handle_member_removed(member){
	var group = this._who;
	var member_id = member.member;

	var newMembers = group.members.filter(function(person){
		return person !== member_id;
	});

	var updatedGroup = xtend(group, {
		members: newMembers
	});

	this._who = updatedGroup;
	this.recalculate();
}

function get_messages(who, page){
	page = page || 0;
	return this._apiPrefix.history(who._id, page)
		.then(add_new_messages.bind(this, page))
		.then(recalculate.bind(this));
}

function add_new_messages(page, list) {
	var cache = this.data.list;
	var loadMore = list.length >= 20;
	var processedList = list.reverse().map(timestampify);
	var allMessageList = page ? processedList.concat(cache) : processedList;
	var unreadList = allMessageList.filter(function(message){
		return !message.attachment;
	}).filter(function(message){
		return !message.read;
	}).map(get_simple_date.bind(this));
	var update = {
		page: page,
		list: allMessageList,
		unreadList: unreadList,
		totalMessageCount: allMessageList.length,
		loadMore: loadMore
	};
	return this.extend(update);
}

function track_group_events(group_id){
	var tracker = this._groupchat_tracker;
	tracker.off();
	tracker.on("mqtt:gc/" + group_id + "/message", handle_new_message.bind(this));
	tracker.on("mqtt:gc/" + group_id + "/members/added", handle_member_added.bind(this));
	tracker.on("mqtt:gc/" + group_id + "/members/removed", handle_member_removed.bind(this));
}

function scroll_down(){
	setTimeout(function () {
		this.dispatch("scroll");
	}.bind(this), 500);
}

function timestampify(item) {
	var attachment = item.attachment;
	var expires_at;
	if(attachment)
		expires_at = attachment.expires_at;
	return xtend(item, {
		expiry: timestamp(expires_at),
		date_expiry: formatDate(expires_at),
		read_timestamp: timestamp(item.updated_at),
		read_formatted_date: formatDate(item.updated_at),
		timestamp: timestamp(item.created_at),
		formatted_date: formatDate(item.created_at)
	});
}

// Converts a date timestamp into a human readable timestamp
function timestamp(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getHours());
	res += ":" + padNumber(d.getMinutes());
	return res;
}

// Converts a date timestamp into a human readable date
function formatDate(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getDate());
	res += "/" + padNumber(d.getMonth() + 1);
	return res;
}

// Pads numbers less than 10 with a 0
function padNumber(number) {
	if (number < 10) return "0" + number;
	return number;
}

function get_simple_date(message){
	return xtend(message, {
		simple_date: this.get_date(new Date(message.updated_at))
	});
}


function get_date(time) {
	var localization = this._localization;
	if (!localization) return;
	var language = localization.language;
	var date = time.getDate();
	var year = time.getFullYear();

	if (language === "fr") {
		return this.get_day(time) + " " + date + " " + this.get_month(time) + " " + year;
	} else {
		return this.get_day(time) + ", " + this.get_month(time) + " " + date + ", " + year;
	}
}

function get_month(time) {
	var localization = this._localization;
	if(!localization) return;
	var month = time.getMonth();

	var months = localization.localization.months;

	var monthData = months[month];
	if ((typeof monthData) === "string") return monthData;
	return monthData.text;
}

function get_day(time) {
	var localization = this._localization;
	if(!localization) return;

	var day = time.getDay();

	var days = localization.localization.days;

	return days[day];
}

function findGroup(groups, group){
	return groups.filter(function(_group){
		return _group._id === group._id;
	})[0];
}

function makeIdMap(elements){
	return elements.reduce(function(map, element){
		map[element._id] = element;
		return map;
	}, {});
}

function handle_contacts_update(contacts) {
	var contactList = contacts;
	var who = this.data.who;

	if(!who || who.members)
		return;

	if(!findContact(contactList, who) && this._prevContacts.length > contacts.length){
		this.handle_view_cancel();
	}

	this._prevContacts = contacts;
}
function findContact(contacts, contact){
	return contacts.filter(function(_contact){
		return _contact._id === contact._id;
	})[0];
}

async function defaultMessage(id) {
	var userId;
	if (typeof (id) === "object") {
		userId = id.id;
	} else {
		userId = id;
	}
	const { persistStorage } = await this.api.persiststorage.getData(userId);
	var message = persistStorage[0]?.data || "";
	this.extend({
		defaultMessage: message
	});
}

